export enum FieldTypes {
    String = 'string',
    Number = 'number',
    Select = 'select',
    Object = 'object',
    Checkbox = 'checkbox',
}

export const JSONSchemaRootPointer = '#' as const;
